import React, { FC, HTMLAttributes } from 'react'
import cn from 'classnames'
import { GxButton } from '@garpix/garpix-web-components-react'
import { JSX } from '@garpix/garpix-web-components'
import style from './styles/index.module.scss'

interface IButton extends HTMLAttributes<HTMLGxButtonElement>, JSX.GxButton {
  theme?:
    | 'btn--default'
    | 'btn--gray'
    | 'btn--transparent_link'
    | 'btn--blue'
    | 'btn--success'
    | 'btn--outline_blue'
    | 'btn--outline_blue_radius'
  disable?: boolean
}

const Button: FC<IButton> = ({
  children,
  theme = 'btn--default',
  className = '',
  disable,
  ...props
}) => {
  return (
    <GxButton {...props} disabled={disable} className={cn(style[theme], { [className]: !!className })}>
      {children}
    </GxButton>
  );
};

export default Button;
